import type { ReactNode } from "react";
export function Container({ children, className = "", prose = false }: { children: ReactNode; className?: string; prose?: boolean }) {
  return <div className={`container-site ${prose ? "max-w-[72ch]" : ""} ${className}`.trim()}>{children}</div>;
}
